"use client";

import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function ClientLove() {
  const testimonials = [{
    quote: "Velvet Shears transformed my hair with a precision cut that feels effortless and incredibly chic.",
    author: "Elena M.",
    suite: "Style Session",
    stayed: "Visited August 2024",
    position: "Client"
  }, {
    quote: "The balayage technique here is unmatched. My color looks vibrant, natural, and perfectly blended.",
    author: "Sarah J.",
    suite: "Color Studio",
    stayed: "Visited July 2024",
    position: "Client"
  }, {
    quote: "Every visit feels like a luxury retreat. The deep-conditioning treatment left my hair feeling brand new.",
    author: "Chloe D.",
    suite: "Treatment Room",
    stayed: "Visited June 2024",
    position: "Client"
  }, {
    quote: "I finally found a salon that understands texture. The styling session was a total game changer for me.",
    author: "Maya K.",
    suite: "Styling Chair",
    stayed: "Visited May 2024",
    position: "Client"
  }, {
    quote: "Professional, artistic, and welcoming. Velvet Shears is truly the gold standard for boutique hair care.",
    author: "Isabella R.",
    suite: "Artistry Suite",
    stayed: "Visited September 2024",
    position: "Client"
  }];
  const [activeIndex, setActiveIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const changeTo = (next: number) => {
    setIsFading(true);
    window.setTimeout(() => {
      setActiveIndex((next + testimonials.length) % testimonials.length);
      setIsFading(false);
    }, 600);
  };
  const handlePrev = () => changeTo(activeIndex - 1);
  const handleNext = () => changeTo(activeIndex + 1);
  useEffect(() => {
    const id = window.setInterval(() => {
      changeTo(activeIndex + 1);
    }, 7000);
    return () => window.clearInterval(id);
  }, [activeIndex]);
  const active = testimonials[activeIndex];
  return <section data-section-id="91" id="client-love" className="relative bg-background text-foreground overflow-hidden dark">
      <div className="relative mx-auto max-w-7xl px-6 sm:px-10 lg:px-16 py-24 sm:py-32 lg:py-40">
        {}
        

        {}
        <Button variant="ghost" size="icon" aria-label="Previous reflection" onClick={handlePrev} className="hidden md:flex absolute left-4 lg:left-8 top-1/2 -translate-y-1/2 h-12 w-12 rounded-lg text-foreground/60 hover:text-foreground hover:bg-transparent">
          <ChevronLeft className="h-6 w-6" strokeWidth={1} />
        </Button>
        <Button variant="ghost" size="icon" aria-label="Next reflection" onClick={handleNext} className="hidden md:flex absolute right-4 lg:right-8 top-1/2 -translate-y-1/2 h-12 w-12 rounded-lg text-foreground/60 hover:text-foreground hover:bg-transparent">
          <ChevronRight className="h-6 w-6" strokeWidth={1} />
        </Button>

        {}
        <div className="relative mx-auto max-w-5xl text-center">
          {}
          <span aria-hidden="true" className="font-serif italic absolute -top-12 sm:-top-16 left-0 sm:-left-4 leading-none select-none pointer-events-none" style={{
          color: "var(--primary)",
          opacity: 0.15,
          fontSize: "clamp(6rem, 14vw, 12rem)"
        }}>
            "
          </span>

          <div className={`transition-opacity duration-700 ease-in-out ${isFading ? "opacity-0" : "opacity-100"}`}>
            <blockquote className="font-serif italic font-light text-foreground/85 leading-[1.15] tracking-tight" style={{
            fontSize: "clamp(2.5rem, 6vw, 5rem)"
          }}>
              {active.quote}
            </blockquote>

            {}
            <div className="mx-auto mt-12 sm:mt-16 h-px" style={{
            width: "60px",
            backgroundColor: "var(--primary)"
          }} />

            {}
            <div className="mt-8 flex items-center justify-center gap-4">
              <div className="hidden sm:block h-10 w-10 rounded-lg overflow-hidden shrink-0" style={{
              backgroundColor: "var(--muted)"
            }} aria-hidden="true">
                <div className="h-full w-full flex items-center justify-center font-serif italic text-sm" style={{
                color: "var(--primary)"
              }}>
                  {active.author.charAt(0)}
                </div>
              </div>
              <p className="font-mono text-[0.7rem] sm:text-xs tracking-[0.25em] uppercase text-muted-foreground">
                {active.author} / {active.suite} / {active.stayed}
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 sm:mt-24 flex items-center justify-center gap-6">
          <Button variant="ghost" size="icon" aria-label="Previous reflection" onClick={handlePrev} className="md:hidden h-9 w-9 rounded-lg text-foreground/60 hover:text-foreground hover:bg-transparent">
            <ChevronLeft className="h-5 w-5" strokeWidth={1} />
          </Button>

          <div className="flex items-center gap-4">
            {testimonials.map((t, i) => <Button key={i} data-index={i} variant="ghost" size="icon" aria-label={`Go to reflection ${i + 1}`} onClick={() => {
            if (i !== activeIndex) changeTo(i);
          }} className="group inline-flex h-4 w-4 items-center justify-center p-0">
                <span className="block h-1.5 w-1.5 rounded-lg transition-all duration-500" style={{
              backgroundColor: "var(--primary)",
              opacity: i === activeIndex ? 1 : 0.3,
              transform: i === activeIndex ? "scale(1.4)" : "scale(1)"
            }} />
              </Button>)}
          </div>

          <Button variant="ghost" size="icon" aria-label="Next reflection" onClick={handleNext} className="md:hidden h-9 w-9 rounded-lg text-foreground/60 hover:text-foreground hover:bg-transparent">
            <ChevronRight className="h-5 w-5" strokeWidth={1} />
          </Button>
        </div>
      </div>
    </section>;
}